import { useTranslation } from 'react-i18next';
import { Truck } from 'lucide-react';
import { formatDate } from '~/utils';

export function ShippedCard({
  shippedDate,
  deliveryStartDate,
  deliveryEndDate,
}: {
  shippedDate?: string | null;
  deliveryStartDate?: string | null;
  deliveryEndDate?: string | null;
}) {
  const { t } = useTranslation('order');

  return (
    <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
      <div className="flex items-start gap-2 mb-2">
        <Truck size="18" className="text-purple-600" />
        <div className="flex-1">
          <p className="text-sm font-medium text-purple-900 mb-1">
            {t('order.order_shipped_status')}
          </p>
          <div className="space-y-1">
            <p className="text-xs text-purple-700">
              <span className="font-medium">{t('order.shipped_on')}</span>{' '}
              {shippedDate && <span>{formatDate(shippedDate)}</span>}
            </p>
            <p className="text-xs text-purple-700">
              <span className="font-medium">
                {t('order.estimated_delivery_date')}
              </span>{' '}
              {deliveryStartDate && (
                <span>{formatDate(deliveryStartDate)}</span>
              )}
              {deliveryEndDate && <span>- {formatDate(deliveryEndDate)}</span>}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
